// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import Button from '@mui/material/Button';
import PopoverButton from './PopoverButton'
import { useCollabModal } from '../../../contexts/CollabModalContext';

function ShareButton({
  hasEditPermission
}) {
  const { showCollabModal } = useCollabModal();

  const button = hasEditPermission ? <Button
    variant="outlined"
    onClick={showCollabModal}
    sx={{
      color: 'black',
      borderColor: '#979797',
      textTransform: 'none',
      minWidth: 'auto',
      padding: '4px 12px',
      fontSize: '14px',
      height: 32,
      '&:hover': {
        borderColor: '#979797',
        backgroundColor: 'white'
      }
    }}
  >
    Share
  </Button> : <PopoverButton
    name="Share"
    onClick={showCollabModal}
    disabled={true}
  >
    You can only view this project. Request edit access from the project owner in order to edit and share.
  </PopoverButton>

  return (
    <div className='shareButton'>
      {button}
    </div>
  );
}

export default ShareButton;
